import { DataAccessRequestStatus } from 'services/data-access-requests/enums'
import type { DataAccessRequestVerificationDetail } from 'services/data-access-requests/types'
import type { GetWorkspaceConfigurationResponse } from 'services/workspaces/v2/types'
import { isAdditionalInformationFormConfiguredForDar } from 'services/workspaces/v2/utils'
import { isAdditionalInfoFormEnabled } from 'utils/env'

export const getIsDataAccessRequestReplica = (dataAccessRequest?: DataAccessRequestVerificationDetail): boolean => {
  if (!isAdditionalInfoFormEnabled() || !dataAccessRequest) {
    return false
  }

  const parentRequestId = dataAccessRequest.parentRequestId?.trim()

  return parentRequestId !== undefined && parentRequestId.length > 0
}

export const getLinkedChildRequestId = (
  dataAccessRequest?: DataAccessRequestVerificationDetail
): string | undefined => {
  if (!isAdditionalInfoFormEnabled() || !dataAccessRequest) {
    return undefined
  }

  const childRequestId = dataAccessRequest.additionalInformation?.submissionRequestId?.trim()

  if (childRequestId === undefined || childRequestId.length === 0) {
    return undefined
  }

  return childRequestId
}

export const getLinkedParentRequestId = (
  dataAccessRequest?: DataAccessRequestVerificationDetail
): string | undefined => {
  if (!isAdditionalInfoFormEnabled() || !dataAccessRequest) {
    return undefined
  }

  const parentRequestId = dataAccessRequest.parentRequestId?.trim()

  if (parentRequestId === undefined || parentRequestId.length === 0) {
    return undefined
  }

  return parentRequestId
}

export const getHasDataAccessRequestAdditionalInformationResponse = (
  dataAccessRequest?: DataAccessRequestVerificationDetail
): boolean => {
  if (!isAdditionalInfoFormEnabled() || !dataAccessRequest) {
    return false
  }

  return dataAccessRequest.additionalInformationSubmission !== undefined
}

export const getIsRequestAdditionalInformationActionVisible = ({
  dataAccessRequest,
  isApprovalActionsVisible,
  sourceWorkspaceConfiguration
}: {
  dataAccessRequest?: DataAccessRequestVerificationDetail
  isApprovalActionsVisible: boolean
  sourceWorkspaceConfiguration?: GetWorkspaceConfigurationResponse
}): boolean => {
  if (!isAdditionalInfoFormEnabled() || !isApprovalActionsVisible || !dataAccessRequest) {
    return false
  }

  if (dataAccessRequest.status !== DataAccessRequestStatus.PendingVerification) {
    return false
  }

  if (getIsDataAccessRequestReplica(dataAccessRequest)) {
    return false
  }

  if (getHasDataAccessRequestAdditionalInformationResponse(dataAccessRequest)) {
    return false
  }

  return isAdditionalInformationFormConfiguredForDar(sourceWorkspaceConfiguration)
}
